import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import QuoteForm from "@/pages/QuoteForm";
import PublicQuote from "@/pages/PublicQuote";
import AcceptedThanks from "@/pages/AcceptedThanks";
import Storytelling from "@/pages/Storytelling";
import LifetimeGuarantee from "@/pages/LifetimeGuarantee";
import Terms from "@/pages/Terms";
import AgreeTerms from "@/pages/AgreeTerms";
import client, { auth } from "@/lib/api";

function RequireAdmin({ children }) {
  const [status, setStatus] = useState("checking");
  useEffect(() => {
    client
      .get("/auth/me")
      .then(() => setStatus("in"))
      .catch(() => {
        auth.clearAdmin();
        setStatus("out");
      });
  }, []);
  if (status === "checking") return null;
  if (status === "out") return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminDashboard />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/quotes/new"
            element={
              <RequireAdmin>
                <QuoteForm mode="create" />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin/quotes/:id"
            element={
              <RequireAdmin>
                <QuoteForm mode="edit" />
              </RequireAdmin>
            }
          />
          <Route path="/q/:slug" element={<PublicQuote />} />
          <Route path="/q/:slug/accepted" element={<AcceptedThanks />} />
          <Route path="/our-storytelling" element={<Storytelling />} />
          <Route path="/lifetime-guarantee" element={<LifetimeGuarantee />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/q/:slug/agree-terms" element={<AgreeTerms />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
